import React from 'react'
import type { IHydrateFormationChartData } from '../../interfaces/interfaces';
import { useAppSelector } from '../../store/hooks/hooks';
import HydrateFormationChart from './HydrateFormationChart';


const EMPTY_CHART_DATA: IHydrateFormationChartData = {
	pressure: 0,
	temperature: 0
};

const ChartSection: React.FC = () => {
	const calculator = useAppSelector(state => state.hydratesCalculator);
	const chartsData = calculator?.chartsData;

	function transformHydratesData(data: {
		pressure: Record<string, number>;
		temperature: Record<string, number>;
	}): IHydrateFormationChartData[] {
		const { pressure, temperature } = data;
		if (pressure == undefined || temperature == undefined) return [];

		const keys = Object.keys(pressure);

		return keys.map(key => ({
			pressure: pressure[key],
			temperature: temperature[key],
		}));
	}

	return <div className="hydrates__charts round-corner-container">
		<div className="hydrates__charts-wrapper">
			{
				<HydrateFormationChart data={transformHydratesData(chartsData ?? EMPTY_CHART_DATA)}></HydrateFormationChart>
			}
		</div>
	</div>
}

export default ChartSection